import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonGroup } from '@fragments';
import { STUDIO_AUTOMATIONS, STUDIO_AUTOMATIONS_LIST } from '../../../../enums/routes';

// The two faces of the feature: where to start, and what is running.
export default function AutomationsTabs({ studio: s, value }) {
  const { t } = useTranslation('studioAutomations');
  return <ButtonGroup size="small" value={value} onChange={path => s.navigate(path)}
    options={[{ value: STUDIO_AUTOMATIONS, label: t('tabHome') }, { value: STUDIO_AUTOMATIONS_LIST, label: t('tabList') }]} />;
}
